/**
 * airan-ntn — Multi-Connectivity xApp
 * Manages dual connectivity setup/teardown for seamless handover
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class MultiConnXApp extends XAppBase {
  private lastReports: Map<number, E2KpmReport> = new Map();

  constructor(enabled: boolean = true) {
    super('multi-conn', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    this.lastReports.set(report.gnbId, report);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, report] of this.lastReports) {
      for (const ueReport of report.ueReports) {
        if (ueReport.sinr < 5 && !report.dcActive) {
          actions.push({
            type: 'DC_SETUP',
            targetId: ueReport.ueId,
            payload: { secondaryGnb: 0, bearerSplit: 'balanced' },
            priority: this.config.priority,
            timestamp: Date.now()
          });
        } else if (ueReport.sinr > 20 && report.dcActive) {
          actions.push({
            type: 'DC_TEARDOWN',
            targetId: ueReport.ueId,
            payload: { reason: 'good_primary_link' },
            priority: this.config.priority,
            timestamp: Date.now()
          });
        }
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.8, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}